<div class="w-full mx-auto rounded-lg max-h-[90vh] flex flex-col">
  <div class="py-2 px-4 flex-shrink-0">
    <div class="titre3 dark:text-white">{{ (data.mode === 'ajouter' ? 'DIFFUSION.ADD_DIFFUSION' : 'DIFFUSION.EDIT_DIFFUSION') | translate }}</div>
  </div>

  <div class="flex-1 overflow-y-auto p-4 min-h-0">
    <div class="mb-4">
      <label class="block mb-2 text-sm font-medium text-gray-700 dark:text-white">
        {{ 'DIFFUSION.SELECT_SCORM_PACKAGE' | translate }}
        <span class="text-red-600">*</span>
      </label>
      <mat-select title="scormPackage" [(ngModel)]="scormPackageSelectionne" [disabled]="isLoading"
        class="w-full p-2 border border-gray-300 rounded dark:text-white"
        panelClass="scorm-package-select-panel"
        panelHeight="300">
        <mat-option>
          <ngx-mat-select-search [formControl]="scormPackageFilterCtrl"
            [placeholderLabel]="'DIFFUSION.SEARCH' | translate"
            [noEntriesFoundLabel]="'DIFFUSION.NO_RESULTS' | translate">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option [value]="null">{{ 'DIFFUSION.SELECT_SCORM_PACKAGE' | translate }}</mat-option>
        @for (package of filteredScormPackages | async; track package) {
          <mat-option [value]="package.scormPackageId">
            {{ getPackageTitle(package) }}
          </mat-option>
        }
      </mat-select>
    </div>

    <div class="mb-4">
      <label class="block mb-2 text-sm font-medium text-gray-700 dark:text-white">
        {{ 'DIFFUSION.SELECT_LANGUAGE' | translate }}
        <span class="text-red-600">*</span>
      </label>
      <select title="langue" [(ngModel)]="langueSelectionnee" [disabled]="isLoading"
        class="w-full p-2 border rounded">
        <option [ngValue]="null">{{ 'DIFFUSION.SELECT_LANGUAGE' | translate }}</option>
        <option value="fr">{{ 'DIFFUSION.LANGUAGE_FR' | translate }}</option>
        <option value="en">{{ 'DIFFUSION.LANGUAGE_EN' | translate }}</option>
        <option value="es">{{ 'DIFFUSION.LANGUAGE_ES' | translate }}</option>
      </select>
    </div>
  </div>

  <div class="py-2 px-4 border-t border-gray-300 dark:border-gray-600 flex-shrink-0 flex justify-end">
    <button (click)="onCancel()" type="button" class="btn-secondary-novo">
      {{ 'DIFFUSION.CANCEL' | translate }}
    </button>
    <button [disabled]="!scormPackageSelectionne || !langueSelectionnee || isLoading" (click)="onSubmit()" type="submit"
      class="btn-primary-novo disabled:opacity-50 disabled:cursor-not-allowed">
      @if (!isLoading) {
        <span>{{ 'DIFFUSION.SAVE' | translate }}</span>
      }
      @if (isLoading) {
        <mat-spinner [diameter]="24" [color]="'accent'"></mat-spinner>
      }
    </button>
  </div>
</div>
